import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import { UiBasicStageInterface } from "@/types/StageInterface";

  type propsType = {
    stage: UiBasicStageInterface;
    lotsAvailableAmount: string | number;
    hoverStageId: string;
  };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StageButtonLink',
  props: {
    stage: {},
    lotsAvailableAmount: {},
    hoverStageId: {}
  },
  emits: ["onStageHover", "onClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const hover = ref(false);

  const props = __props;

  const emits = __emit;

  const onHover = () => {
    hover.value = true;
    emits("onStageHover", true, props.stage.id);
  };

  const onMouseLeave = () => {
    hover.value = false;
    emits("onStageHover", false, props.stage.id);
  };

  const onClick = () => {
    emits("onClick", props.stage.id);
  };

  watch(
    () => props.hoverStageId,
    () => {
      if (props.hoverStageId === props.stage.id) {
        hover.value = true;
      } else {
        hover.value = false;
      }
    }
  );

const __returned__ = { hover, props, emits, onHover, onMouseLeave, onClick, ref, watch, get UiBasicStageInterface() { return UiBasicStageInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})